import api from '@/services/api'
import denormalize from '@/utils/denormalizeResponse'

export async function retrieveUser({ commit }) {
    const response = await api.get('/api/v2/me', {
        query: {
            include: {
                usingProfileKey: true,
                firstName: true,
                lastName: true,
                gender: true,
                teamAffiliations: {
                    team: {
                        name: true,
                    },
                },
                isAdmin: true,
                sport: {
                    name: true,
                },
                clubAffiliations: {
                    organization: {
                        gender: true,
                    },
                },
                organization: {
                    gender: true,
                },
                highSchoolAffiliations: {
                    organization: {
                        gender: true,
                    },
                },
                program: {
                    sport: {
                        name: true,
                    },
                    gender: true,
                },
            },
        },
    })

    const { root: user } = denormalize(response)

    commit('retrieveUserSuccess', user)
}

export async function bootstrapUser({ commit }, userData) {
    commit('retrieveUserSuccess', userData);
}